"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Hustler = function Hustler(_ref) {
  var borderColor = _ref.borderColor,
      offsetColor = _ref.offsetColor;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 179 209"
  }, _react.default.createElement("path", {
    fill: "#63DC3E",
    d: "M38.11 118.28V1.06L.01.87V128.9H27l11.12-10.62zm-31.4 4.22V7.3l24.7.13v108.2l-7.2 6.87H6.72zm133.05-98.41l.27 104.81h38.11v-105l-38.38.19zm31.68 98.41h-24.72l-.24-92.05 24.96-.11v92.16zm-86.51-10.76V57.52h-38.1v50.68l17.2-16.44 20.9 19.98zm-31.4-19v-28.8h24.7v32.34l-9.46-9.04-4.74-4.52-4.74 4.52-5.77 5.5zm78.21-35.21h-38.1v80.59h38.1v-80.6zm-6.7 74.19h-24.7v-67.8h24.7v67.8z"
  }), _react.default.createElement("path", {
    fill: "#63DC3E",
    d: "M170.42 158.35l-44.07 43.36H59.42l-19.2-19.46 53.2-50.75-29.18-28-54.07 51.03-2.57-2.46v-13.29H.38v16.28l9 8.58.86.97 9.44-9.05 44.55-42.36 19.04 18.3-48.13 45.91-5.52 5.24 25.95 26.04h73.82l48.34-47.47v-22.24h-7.31v19.37z"
  }));
};

Hustler.propTypes = {
  borderColor: _propTypes.default.string,
  offsetColor: _propTypes.default.string
};
Hustler.defaultProps = {
  borderColor: "#242523",
  offsetColor: "#63DC3E"
};
var _default = Hustler;
exports.default = _default;